// extracted by mini-css-extract-plugin
export default {"mainContainer":"Footer_mainContainer__kwuKW","linkContainer":"Footer_linkContainer__2Uisr"};